// extracted by mini-css-extract-plugin
export default {"label":"ArchitectureLabelPicker_label__pfjUe","pickerContainer":"ArchitectureLabelPicker_pickerContainer__v8-pq"};